import {
  GET_LOGISTICS_INFO,
  GET_LOGISTICS_INFO_ERROR,
} from "../constants/LogisticsConstants";
import Axios from "axios";
import { API_ROOT } from "../components/utils/api-config";
let token = "Bearer " + localStorage.getItem("token");
const config = {
  headers: {
    Authorization: token,
  },
};
export const getLogisticsInfo = () => (dispatch) => {
  Axios.get(`${API_ROOT}/routes/`, config)
    .then((response) =>
      dispatch({ type: GET_LOGISTICS_INFO, payload: response.data })
    )
    .catch((error) =>
      dispatch({ type: GET_LOGISTICS_INFO_ERROR, payload: error })
    );
};
